const users = state => state.users
const user = state => state.user

export default {
  users,
  user
};
